import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { IndependenceModel } from '../../declaration.model';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CommonMessageService } from 'src/app/services/common-message.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-all-client',
  templateUrl: './all-client.component.html',
  styleUrls: ['./all-client.component.css'],
})
export class AllClientComponent implements OnInit {
  financialList;
  employeeList;
  @Input() isMyReport: boolean;
  @Input() clientIndependence: IndependenceModel;

  selectedFinancialYear;
  selectedProfile;
  selectedEmployee;
  constructor(
    private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private commonMessageService:CommonMessageService
  ) { }

  ngOnInit(): void {
    this.selectedProfile = "";
    this.selectedFinancialYear = "";
    this.selectedEmployee = "";

    if (!this.isMyReport) {
      this.loadInitDetails();
    }
  }
  loadInitDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
    // this.humanResourceService.getProfiles().subscribe((res) => {
    //   this.employeeList = res;
    //   console.log('employee name', this.employeeList);
    // });
  }

  onStatusSelect() {
    console.log('status select', this.selectedProfile);
    this.humanResourceService.getEmployeeProfile(this.selectedProfile).subscribe((res: any) => {
      this.employeeList = res;
      console.log('employee list', this.employeeList);
    })
  }

  onViewReport() {
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == "" ||
      this.selectedProfile == "" ||
      this.selectedProfile == null ||
      this.selectedProfile == undefined ||
      this.selectedEmployee == null ||
      this.selectedEmployee == undefined ||
      this.selectedEmployee == ""
    )
       this.commonMessageService.swalAlertWithoutIcon('','Please choose the values before pressing report');
    else {
      this.masterDataService
        .getAllClientIndependence(
          this.selectedFinancialYear.id,
          this.selectedEmployee.id,
          this.selectedProfile
        )
        .subscribe((res) => {
          this.clientIndependence = res;
          console.log('clientIndependence', res);
          if (this.clientIndependence == null) {
             this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
            this.showExcelButton=false;
          }else{
            this.showExcelButton=true;
          }
          console.log('response', res);
        });
    }
  }

  validateAggreQuestion(answer) {
    if (answer == 1) {
      return true;
    } else {
      return false;
    }
  }

  showExcelButton:Boolean;
  onExportToExcelReport(){
    this.masterDataService.getAllClientIndependenceExcel(this.selectedFinancialYear.id,
      this.selectedEmployee.id,
      this.selectedProfile).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "AnnualDeclaration.xlsx";
      link.click();
    });
  }

  exportToPDFClick(){
    var docDefinition = {
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'Annual Independence for all Clients Confirmation', fontSize: 18, bold: true, alignment: 'center', margin: [0, 15, 0, 15] });
    docDefinition.content.push({text: `Name of Article/Employee/Partner:${'                      '}${this.clientIndependence.firstName} ${this.clientIndependence.lastName}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `Designation:${'                                                              '} ${this.clientIndependence.role}`,bold:true,margin: [0, 5, 0, 5]});
    docDefinition.content.push({text: `For assignments in respect of FY:${'                          '}${this.clientIndependence.fyName}`,bold:true,margin:[0, 5, 0, 5]});
    docDefinition.content.push({text: `Branch:${'                                                                        '}${this.clientIndependence.branch}`,bold:true,margin:[0, 5, 0, 5]});
    docDefinition.content.push({text: 'DETAILED DECLARATIONS',margin:[0, 15, 0, 5]});
    docDefinition.content.push({text: `${this.clientIndependence.beginText}`,bold:true,margin:[0, 5, 0, 10]});

    docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: [40, '*', 60],
          body: [
            [{ text: 'Sr. No', bold:true, margin: [0, 5, 0, 5] }, { text: 'Declaration', bold:true, margin: [0, 5, 0, 5] }, { text: '	Agree / Disagree', bold:true, margin: [0, 5, 0, 5] }],
            ...this.clientIndependence.empIndepenDeclarationDetails.map((res,index) => [{ text:index+1 }, { text: res.question},  { text: `${res.answer?'Yes':'No'}`}]),
           
          ]
        }
      }
      );
      docDefinition.content.push({text: 'Explanation in cases where disagree responses are given',margin:[0, 15, 0, 0],bold:true});
      docDefinition.content.push({text: `${this.clientIndependence.dissagreementAnswer}`,margin:[0, 5, 0, 10]});
      docDefinition.content.push({text: `${this.clientIndependence.declaration}`,margin:[0, 15, 0, 10],bold:true});
      docDefinition.content.push({text: 'REPRESENTATION',margin:[0, 5, 0, 5],bold:true});
      docDefinition.content.push({text: `${this.clientIndependence.endText}`,margin:[0, 5, 0, 5],bold:true});
      docDefinition.content.push({text: `Sign:${'                      '} Yes`,margin: [0, 5, 0,4]});
      docDefinition.content.push({text: `Date:${'                       '}${moment(this.clientIndependence.signedDate).format('DD-MMM-yyyy')}`,margin:[0, 0, 0, 4]});

    pdfMake.createPdf(docDefinition).download('AnnualDeclaration.pdf');
  }
}
